import * as Yup from 'yup';

export const productCategorySiteSchema = Yup.object().shape({
  description: Yup.string().required('Descrição é obrigatória.'),
  active: Yup.boolean().required(),
});